export const MODULATORS_CONSUMPTION_CHART_CARD_FRENCH_LOCALE = {
  title: "Consommation du modulateur",
};
